var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('UserList'),_c('mars-map',{attrs:{"url":_vm.configUrl,"options":_vm.options},on:{"onload":_vm.onMapload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }